<script lang="ts">
	import { page } from '$app/stores';
	import logo from '$lib/assets/siposdani87-logo.svg';
	import { siteBaseUrl } from '$lib/meta';
	import ThemeToggle from '$lib/components/theme-toggle.svelte';
</script>

<header
	class="bg-surface/80 text-text px-5 py-3 flex justify-between items-center sticky top-0 border-b border-border/50 z-50 backdrop-blur-md"
>
	<a href="/" class="flex items-center">
		<img src={logo} alt="siposdani87" class="logo w-10" width="40" height="40" />
		<strong class="inline-block ml-2 truncate text-sm font-semibold">BLOG.siposdani87</strong>
	</a>

	<div class="flex items-center gap-1">
		<nav aria-label="Main navigation">
			<ul class="flex">
				<li class:active={$page.url.pathname === '/'}>
					<a href="/" class="text-sm font-medium text-text-secondary hover:text-text">Home</a>
				</li>
				<li class:active={$page.url.pathname === '/posts'}>
					<a href="/posts" class="text-sm font-medium text-text-secondary hover:text-text">Posts</a>
				</li>
				<li>
					<a
						href={siteBaseUrl}
						target="_blank"
						rel="noreferrer"
						class="text-sm font-medium text-text-secondary hover:text-text">About</a
					>
				</li>
			</ul>
		</nav>
		<ThemeToggle />
	</div>
</header>

<style lang="postcss">
	@reference "../../app.css";

	header {
		view-transition-name: header;
	}
	:global(.dark) .logo {
		filter: invert(100%) sepia(19%) saturate(2%) hue-rotate(23deg) brightness(102%) contrast(101%);
	}
	li {
		@apply px-3;
	}

	.active a {
		@apply text-text font-semibold border-b-2 border-primary;
	}
</style>
